module.exports = __webpack_public_path__ + "static/media/Choose_Install_Finished.00c069fb.svg";